import { CommonModule, NgFor, NgIf } from '@angular/common';
import { Component, Inject, ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { TFMService } from 'app/mock-api/tfm.service';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { FormsModule } from '@angular/forms';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-reserve-dialog',
  standalone: true,
  imports: [CommonModule,NgIf,NgFor, FormsModule],
  templateUrl: './reserve-dialog.component.html',
  styleUrl: './reserve-dialog.component.scss'
})
export class ReserveDialogComponent {
  prebookCompleted$ = new Subject<boolean>();

  public view : any = {

    itineraryOption: {
      payments: {
        content: [] 
      }
    },
    occupancy:[],
    itinerary: {
      remarks: '' // Initialize the remarks property
    },
    isViewOnly: false
  }
 

  constructor(private _tfmService : TFMService, public dialogRef: MatDialogRef<ReserveDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any,private _confirmationService: FuseConfirmationService,private dialog: MatDialog, private cdr: ChangeDetectorRef){
    this._tfmService.log("Data - : ",data);
    this.view.itineraryOption = this.data.itinerary;
    this.view.isViewOnly = Boolean(this.data?.viewOnly);
    this._tfmService.log("Data - 2 : ",this.view.itineraryOption );

    this.view.occupancy.push({ adultCount: 2, teenCount: 0, childCount: 0, infantCount: 0 });

  }

  ngOnInit() {
    this.setItineraryOption(this.data.itinerary, false); 
  }
  
  openConfirmationModal(config?: { title?: string; message?: string; showClose?: boolean; showViewQuotes?: boolean; showNewQuote?: boolean;}) {
      this.dialog.open(ConfirmationDialogComponent, {
        data: config
      });
    }

    private loadAvailableRooms(item: any) {
      var roomAvailLink = item._links.find(x => x.name == "room-availability")?.href; 
      if(roomAvailLink){
        this._tfmService.send({href: roomAvailLink, method:"get"}).subscribe(resRoomAvail => {
          // Clear existing rooms first
          item.availableRoom = [];
          
          resRoomAvail.data[0].results.roomStays.roomStay.forEach(room => {
            item.availableRoom.push(room.basicPropertyInfo.hotelCode);
          });
          
          // Reset selection
          item.selectedRoom = null;
          
          // Trigger change detection to update UI
          if (this.cdr) {
            this.cdr.detectChanges();
          }
        });
      }
    }
  public setItineraryOption(itinerary, setItin = false) {
    this.view.itineraryOption = itinerary;

    if (setItin) {
      this.view.guid = this.view.itineraryOption.guid;
      this._tfmService.setLocalItinGuid(this.view.guid);

      // this.itinLoad();
    }

    if (this.view.itineraryOption && this.view.itineraryOption.items) {
      console.log("this.view.itineraryOption.items",this.view.itineraryOption.items)
      this.view.occupancy = [];
      var occupancy: any[] = [];
      var count = 0;
      //Generate occupancy based on accommodation items
      this.view.itineraryOption.items.content.forEach(item => {
        if (item.searchType == 1) {
          //Get existing pax mapped
          count++;
          this._tfmService.filterAndSend(item._links, "persons").subscribe(resItemPersons => {
            count--;
            //console.log(resItemPersons);

            var adults = resItemPersons.content.filter(x => x.type == 1);
            var teens = resItemPersons.content.filter(x => x.type == 3);
            var children = resItemPersons.content.filter(x => x.type == 2);
            var infants = resItemPersons.content.filter(x => x.type == 4);

            var childAgesSplit = item.childAges ? item.childAges.split(",") : [];

            adults.filter(x => x.dateOfBirth).forEach(pax => {
              pax.dateOfBirth = pax.dateOfBirth ? new Date(pax.dateOfBirth) : null;
              if (pax.dateOfBirth)
                pax.dateOfBirth.setHours(pax.dateOfBirth.getHours() + 2);

              pax.dateOfBirth = new Date(pax.dateOfBirth).toISOString().substring(0, 10);
              pax.minDate = this._tfmService.subtractYears(new Date(), 18);
            });
            teens.filter(x => x.dateOfBirth).forEach(pax => {
              pax.dateOfBirth = pax.dateOfBirth ? new Date(pax.dateOfBirth) : null;
              if (pax.dateOfBirth)
                pax.dateOfBirth.setHours(pax.dateOfBirth.getHours() + 2);

              pax.dateOfBirth = new Date(pax.dateOfBirth).toISOString().substring(0, 10);
            });
            children.filter(x => x.dateOfBirth).forEach((pax, x) => {
              pax.dateOfBirth = pax.dateOfBirth ? new Date(pax.dateOfBirth) : null;
              if (pax.dateOfBirth)
                pax.dateOfBirth.setHours(pax.dateOfBirth.getHours() + 2);

              pax.dateOfBirth = new Date(pax.dateOfBirth).toISOString().substring(0, 10);
              pax.minDate = this._tfmService.subtractYears(new Date(), childAgesSplit && childAgesSplit.length > x ? childAgesSplit[x] : 12)
            });
            infants.filter(x => x.dateOfBirth).forEach(pax => {
              pax.dateOfBirth = pax.dateOfBirth ? new Date(pax.dateOfBirth) : null;
              if (pax.dateOfBirth)
                pax.dateOfBirth.setHours(pax.dateOfBirth.getHours() + 2);

              pax.dateOfBirth = new Date(pax.dateOfBirth).toISOString().substring(0, 10);
            });

            // Initialize room selection properties on the item
            if (!item.availableRoom) {
              item.availableRoom = [];
            }
            if (!item.selectedRoom) {
              item.selectedRoom = null;
            }

            var occ = {
              id: item.id,
              adultCount: item.adultCount,
              adults: adults,
              teenCount: item.teenCount,
              teens: teens,
              childCount: item.childCount,
              children: children,
              childAges: item.childAges,
              infantCount: item.infantCount,
              infants: infants,
              item: item
            };

            for (var x = occ.adults.length; x < occ.adultCount; x++) {
              occ.adults.push({
                minDate: this._tfmService.subtractYears(new Date(), 18)
              });
            }
            for (var x = occ.teens.length; x < occ.teenCount; x++) {
              occ.teens.push({});
            }
            for (var x = occ.children.length; x < occ.childCount; x++) {
              occ.children.push({
                minDate: this._tfmService.subtractYears(new Date(), childAgesSplit && childAgesSplit.length > x ? childAgesSplit[x] : 12)
              });
            }
            for (var x = occ.infants.length; x < occ.infantCount; x++) {
              occ.infants.push({});
            }

            occupancy.push(occ);

            // Load available rooms for this item
            this.loadAvailableRooms(item);

            if (count == 0) {
              this.view.occupancy = occupancy.sort((a, b) => a.id - b.id);
            }
          });

          //Load supplier facts
          // this.loadSupplierFacts(item, item.supplierID);
        }
      });
    }
    else {
      //Set occupancy fields
      this.view.occupancy.forEach(room => {
        room.adults = [];
        room.teens = [];
        room.children = [];
        room.infants = [];

        for (var x = 0; x < room.adultCount; x++) {
          room.adults.push({});
        }
        for (var x = 0; x < room.teenCount; x++) {
          room.teens.push({});
        }
        for (var x = 0; x < room.childCount; x++) {
          room.children.push({});
        }
        for (var x = 0; x < room.infantCount; x++) {
          room.infants.push({});
        }
      });
    }

    //console.log("this.view.itineraryOption", this.view);

  }
  updateRoomSelection(item){
          var roomSelectionLink = item._links.find(x => x.rel == "edit")?.href; 
        item.serviceDescription = item.selectedRoom;
          // Replace this with your actual API call
         this._tfmService.send({
            href: roomSelectionLink, // Replace with actual endpoint
            method: 'put',
          }, item).subscribe();
  }
  async itinPersonAdd(itinOption, book = false) {
    //var itinGuid = this.tfmService.getLocalItinGuid();
    //console.log("OPTION", itinOption, this.view);

    var content : any = {};
    
    await this._tfmService.getItin(itinOption.guid).subscribe(async (res) => {
      await this._tfmService.filterAndSend(res.content.itinerary._links, "persons").subscribe(async (resPersons) => {
        //console.log("PERSONS", resPersons);

        for await (const [roomIndex, room] of this.view.occupancy.entries()) {
        //this.view.occupancy.forEach((room, roomIndex) => {
          for await (const [index, p] of room.adults.entries()) {
          //room.adults.forEach((p, index) => {
            p.dateOfBirth = p.dateOfBirth ? new Date(p.dateOfBirth) : null;
            if (p.dateOfBirth)
              p.dateOfBirth.setHours(p.dateOfBirth.getHours() + 2);

            content = {
              IsLead: roomIndex == 0 && index == 0,
              Title: p.title,
              EmailAddress: p.emailAddress,
              FirstName: p.firstName,
              LastName: p.lastName,
              CountryAccessCode: p.countryAccessCode,
              AreaCityCode: p.areaCityCode,
              PhoneNumber: p.phoneNumber,
              Type: 1,
              Notes: p.notes,
              DateOfBirth: p.dateOfBirth
            };

            //Check if we have this person type already in the list, and just update it
            if (resPersons.content.filter(x=>x.type == content.Type).length > (roomIndex + index)) {
              p.id = resPersons.content.filter(x=>x.type == content.Type)[(roomIndex + index)].id;
            }

            if (p.id > 0) { //Existing person, just update their details
              await this._tfmService.filterAndSendAsPromise(resPersons.content.filter(x => x.id == p.id)[0]._links, "edit", content).then(async (resPersonAdd) => {
                console.log("Pax updated");
              });
            }
            else { //Add new person and map to service items
              await this._tfmService.filterAndSendAsPromise(resPersons._links, "add", content).then(async (resPersonAdd) => {
                //console.log("Pax added");
                //console.log("PERSON ADD", resPersonAdd);

                //Assign person to items
                for await (const [itemIndex, item] of itinOption.items.content.entries()) {
                //itinOption.items.content.forEach(async (item) => {
                  if (item.searchType != 1 || (item.searchType == 1 && (!room.item || item.id == room.item.id))) { //Only map this person to this accommodation item if it matches - all other services get all pax mapped
                    await this._tfmService.filterAndSendAsPromise(item._links, "persons").then(async (resItemPersons) => {
                      let link = this._tfmService.getLink(resItemPersons._links, "add");
                      link.href = link.href.replace("{personId}", resPersonAdd.id);

                      await this._tfmService.send(link).subscribe(resItemPersonAdd => {
                        console.log("Pax added");
                        
                        console.log("PERSON ADDDED TO ITEM", resItemPersonAdd);
                      });
                    });
                  }
                };
              });
            }
          };
          for await (const [index, p] of room.teens.entries()) {
          //room.teens.forEach((p, index) => {
            p.dateOfBirth = p.dateOfBirth ? new Date(p.dateOfBirth) : null;
            if (p.dateOfBirth)
              p.dateOfBirth.setHours(p.dateOfBirth.getHours() + 2);

            content = {
              IsLead: 0,
              Title: p.title,
              EmailAddress: p.emailAddress,
              FirstName: p.firstName,
              LastName: p.lastName,
              CountryAccessCode: p.countryAccessCode,
              AreaCityCode: p.areaCityCode,
              PhoneNumber: p.phoneNumber,
              Type: 3,
              Notes: p.notes,
              DateOfBirth: p.dateOfBirth
            };

            //Check if we have this person type already in the list, and just update it
            if (resPersons.content.filter(x=>x.type == content.Type).length > (roomIndex + index)) {
              p.id = resPersons.content.filter(x=>x.type == content.Type)[(roomIndex + index)].id;
            }

            if (p.id > 0) { //Existing person, just update their details
              await this._tfmService.filterAndSendAsPromise(resPersons.content.filter(x => x.id == p.id)[0]._links, "edit", content).then(async (resPersonAdd) => {
                console.log("Pax updated");
                
              });
            }
            else { //Add new person and map to service items
              await this._tfmService.filterAndSendAsPromise(resPersons._links, "add", content).then(async (resPersonAdd) => {
                //console.log("Pax added");
                //console.log("PERSON ADD", resPersonAdd);

                //Assign person to items
                for await (const [itemIndex, item] of itinOption.items.content.entries()) {
                //itinOption.items.content.forEach(item => {
                  if (item.searchType != 1 || (item.searchType == 1 && (!room.item || item.id == room.item.id))) { //Only map this person to this accommodation item if it matches - all other services get all pax mapped
                    await this._tfmService.filterAndSendAsPromise(item._links, "persons").then(async (resItemPersons) => {
                      let link = this._tfmService.getLink(resItemPersons._links, "add");
                      link.href = link.href.replace("{personId}", resPersonAdd.id);

                      await this._tfmService.send(link).subscribe(resItemPersonAdd => {
                        console.log("Pax added")
                       
                        //console.log("PERSON ADDDED TO ITEM", resItemPersonAdd);
                      });
                    });
                  }
                };
              });
            }
          };
          for await (const [index, p] of room.children.entries()) {
          //room.children.forEach((p, index) => {
            p.dateOfBirth = p.dateOfBirth ? new Date(p.dateOfBirth) : null;
            if (p.dateOfBirth)
              p.dateOfBirth.setHours(p.dateOfBirth.getHours() + 2);

            content = {
              IsLead: 0,
              Title: p.title,
              EmailAddress: p.emailAddress,
              FirstName: p.firstName,
              LastName: p.lastName,
              CountryAccessCode: p.countryAccessCode,
              AreaCityCode: p.areaCityCode,
              PhoneNumber: p.phoneNumber,
              Type: 2,
              Notes: p.notes,
              DateOfBirth: p.dateOfBirth
            };

            //Check if we have this person type already in the list, and just update it
            if (resPersons.content.filter(x=>x.type == content.Type).length > (roomIndex + index)) {
              p.id = resPersons.content.filter(x=>x.type == content.Type)[(roomIndex + index)].id;
            }

            if (p.id > 0) { //Existing person, just update their details
              await this._tfmService.filterAndSendAsPromise(resPersons.content.filter(x => x.id == p.id)[0]._links, "edit", content).then(async (resPersonAdd) => {
                console.log("Pax updated");
                
              });
            }
            else { //Add new person and map to service items
              await this._tfmService.filterAndSendAsPromise(resPersons._links, "add", content).then(async (resPersonAdd) => {
                //console.log("Pax added");
                //console.log("PERSON ADD", resPersonAdd);

                //Assign person to items
                for await (const [itemIndex, item] of itinOption.items.content.entries()) {
                //itinOption.items.content.forEach(item => {
                  if (item.searchType != 1 || (item.searchType == 1 && (!room.item || item.id == room.item.id))) { //Only map this person to this accommodation item if it matches - all other services get all pax mapped
                    await this._tfmService.filterAndSendAsPromise(item._links, "persons").then(async (resItemPersons) => {
                      let link = this._tfmService.getLink(resItemPersons._links, "add");
                      link.href = link.href.replace("{personId}", resPersonAdd.id);

                      await this._tfmService.send(link).subscribe(resItemPersonAdd => {
                        console.log("Pax added");
                        
                        //console.log("PERSON ADDDED TO ITEM", resItemPersonAdd);
                      });
                    });
                  }
                };
              });
            }
          };
          for await (const [index, p] of room.infants.entries()) {
          //room.infants.forEach((p, index) => {
            p.dateOfBirth = p.dateOfBirth ? new Date(p.dateOfBirth) : null;
            if (p.dateOfBirth)
              p.dateOfBirth.setHours(p.dateOfBirth.getHours() + 2);

            content = {
              IsLead: 0,
              Title: p.title,
              EmailAddress: p.emailAddress,
              FirstName: p.firstName,
              LastName: p.lastName,
              CountryAccessCode: p.countryAccessCode,
              AreaCityCode: p.areaCityCode,
              PhoneNumber: p.phoneNumber,
              Type: 4,
              Notes: p.notes,
              DateOfBirth: p.dateOfBirth
            };

            //Check if we have this person type already in the list, and just update it
            if (resPersons.content.filter(x=>x.type == content.Type).length > (roomIndex + index)) {
              p.id = resPersons.content.filter(x=>x.type == content.Type)[(roomIndex + index)].id;
            }

            if (p.id > 0) { //Existing person, just update their details
              await this._tfmService.filterAndSendAsPromise(resPersons.content.filter(x => x.id == p.id)[0]._links, "edit", content).then(async (resPersonAdd) => {
                console.log("Pax updated");
                this.dialogRef.close();
              });
            }
            else { //Add new person and map to service items
              await this._tfmService.filterAndSendAsPromise(resPersons._links, "add", content).then(async (resPersonAdd) => {
                //console.log("Pax added");
                //console.log("PERSON ADD", resPersonAdd);

                //Assign person to items
                for await (const [itemIndex, item] of itinOption.items.content.entries()) {
                //itinOption.items.content.forEach(item => {
                  if (item.searchType != 1 || (item.searchType == 1 && (!room.item || item.id == room.item.id))) { //Only map this person to this accommodation item if it matches - all other services get all pax mapped
                    await this._tfmService.filterAndSendAsPromise(item._links, "persons").then(async (resItemPersons) => {
                      let link = this._tfmService.getLink(resItemPersons._links, "add");
                      link.href = link.href.replace("{personId}", resPersonAdd.id);

                      await this._tfmService.send(link).subscribe(resItemPersonAdd => {
                        console.log("Pax added");
                        //console.log("PERSON ADDDED TO ITEM", resItemPersonAdd);
                      });
                    });
                  }
                };
              });
            }
          };
          this.dialogRef.close();
          setTimeout(() => {
            
            this.itinPreBook(itinOption.guid, book);
        }, 3000);

          // this.openConfirmationModal({
          //   title: 'Reserved',
          //   message: 'Your Pax details are updated and your booking has been successfully reserved and is pending confirmation from the supplier',
          //   showClose: true,
          //   showViewQuotes: true,
          //   showNewQuote: true
          // });
        };

      });
    });
  }
  
    itinPreBook(itinGuid, book = false) {
    //var itinGuid = this.tfmService.getLocalItinGuid();

    this._tfmService.getItin(itinGuid).subscribe(res => {
      res.content.itinerary.remarks = this.view.itinerary.remarks;

      this._tfmService.filterAndSend(res.content.itinerary._links, "edit", res.content.itinerary).subscribe(resItin => {
       // this.toaster.success("Remarks added...");

        this._tfmService.filterAndSend(res.content.itinerary._links, "prebook").subscribe(resPrebook => {
        this.itinOptionsLoad();
        this.prebookCompleted$.next(true);
        this.prebookCompleted$.complete();

        });
      });
    });
  }
  itinUnPreBook(itinGuid, book = false) {
    //var itinGuid = this.tfmService.getLocalItinGuid();

    this._tfmService.getItin(itinGuid).subscribe(res => {
      this._tfmService.filterAndSend(res.content.itinerary._links, "unprebook").subscribe(resUnPrebook => {
       // this.toaster.success("Un-Reserved complete");
        //console.log("PREBOOK", resPrebook);

        this.itinOptionsLoad();
       // this.modalService.dismissAll();
      });
    });
  }

 

  //To be implmented
  itinOptionsLoad(){
        var itinGuid = this._tfmService.getLocalItinGuid();

this._tfmService.getItinOptions(itinGuid).subscribe(resOptions => {

      var res = resOptions.content;

      res.forEach(option => {
        this._tfmService.getItinItems(option.itinerary.guid).subscribe(optionItems => {
          option.itinerary.items = optionItems;

          this._tfmService.filterAndSend(option.itinerary._links, "payments").subscribe(res => {
            option.itinerary.payments = res;
          });
        });

        // this.getPayments(option.itinerary);
        // console.log("getPayments");
      });
    });
  }
  // getItinItems(quote) {
  //   this._tfmService.getItinItems(quote.itinerary.guid).subscribe(res => {
  //     quote.items = res;
  //   });

  //   this._tfmService.log("QUOTE ITEMS", quote.itinerary.option, quote);
  // }
  close(): void
  {
      this.dialogRef.close();
  }
  public toNumber(text) {
    return Number(text);
  }

}
